import FaqsWrapper from 'Pages/FaqsWrapper';
import api from '../../api';
import getBuildTime from '../../services/build/getBuildTime';
import getInitialReduxState from '../../services/page/getInitialReduxState';

export default function Faqs(props) {
   return <FaqsWrapper {...props} />;
}

export async function getStaticPaths(locale, storeId = process.env.NEXT_PUBLIC_STORE_ID) {
   // obtenemos las preguntas frecuentes
   const frequent = await api.faqs.get(storeId, true);

   // generamos un array de objetos
   // esto es para que next haga un pre-render al hacer el build
   // de las paginas que tengan esos slug (las preguntas frecuentes)
   const paths = frequent.data.map((x) => ({
      params: {
         slug: x.slug,
      },
   }));

   return {
      // retornamos el array
      paths,
      fallback: 'blocking',
   };
}

export async function getStaticProps(context, storeId = process.env.NEXT_PUBLIC_STORE_ID) {
   const { params } = context;
   const startTime = new Date();
   const initialReduxState = await getInitialReduxState(storeId);
   const faqs = await api.faqs.get(storeId);

   if (!faqs.success) {
      throw new Error(faqs.error);
   }

   const activeFaq = faqs.data.find((x) => x.slug === params.slug) || {};

   return {
      props: {
         initialReduxState,
         buildInfo: {
            generatedAt: startTime.toLocaleTimeString(),
            execTime: getBuildTime(startTime),
            path: '/faqs',
         },
         faqs: faqs.data,
         slug: params.slug,
         activeFaq,
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once 5 second
      revalidate: 10, // In seconds
   };
}
